import moment from 'moment'

export const getUnpublishedShiftSummary = UserCsvRecords => {
  const unpublishedRecords = UserCsvRecords.filter(
    record => !record.isDelete && record.isPublished === false
  )

  if (unpublishedRecords.length === 0) return null

  const workDates = unpublishedRecords
    .map(record => moment(record.startTime).format('YYYY-MM-DD'))
    .sort()

  return {
    count: unpublishedRecords.length,
    earliestDate: workDates[0],
    latestDate: workDates[workDates.length - 1],
  }
}
